import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const VisibilityNone = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M29.7689 15.3606C29.519 15.0601 23.5617 8 16 8C14.0625 8 12.2307 8.46412 10.5729 9.15862L5.70687 4.29275C5.52587 4.11187 5.276 4 5 4C4.44775 4 4 4.44775 4 5C4 5.276 4.11187 5.52587 4.29262 5.70675L8.67262 10.0868C4.89937 12.1946 2.39137 15.1678 2.23112 15.3605C1.923 15.731 1.923 16.2686 2.23112 16.6391C2.481 16.9396 8.43825 23.9998 16 23.9998C17.9375 23.9998 19.7692 23.5356 21.4271 22.8411L26.293 27.707C26.474 27.888 26.724 27.9999 27 27.9999C27.5522 27.9999 28 27.5521 28 26.9999C28 26.7239 27.8881 26.474 27.7074 26.293L23.3274 21.913C27.1006 19.8051 29.6086 16.832 29.7689 16.6392C30.077 16.2687 30.077 15.7311 29.7689 15.3606V15.3606ZM16 22C10.6277 22 5.9505 17.6643 4.35337 16C5.326 14.9865 7.44112 12.9846 10.1581 11.5724L10.4081 11.8224C10.145 12.4975 10 13.2318 10 14C10 17.3138 12.6862 20 16 20C16.7682 20 17.5026 19.8552 18.1779 19.5921L19.8766 21.2909C18.6532 21.7265 17.3486 22 16 22ZM21.8419 20.4276L12.1234 10.7091C13.3467 10.2735 14.6514 10 16 10C21.3717 10 26.0489 14.3351 27.6466 16C26.674 17.0135 24.559 19.0155 21.8419 20.4276Z" />
	</svg>
);

export default VisibilityNone;
